module.exports = __webpack_public_path__ + "static/media/S1-18-Zartropoolz-cod18.2aaa7433.png";